<ul role="tablist">
    <li *ngFor="let block of blocks; let index = index"
        [ngSwitch]="block.type"
        class="carousel-block carousel-block-{{index}} {{block.type | kebabCase}}"
        role="tab"
    >
        <!-- Image Block -->
        <div *ngSwitchCase="'imageBlock'" [ngClass]="block.style">
            @defer {
                <finder-image-block
                    [blockData]="block"
                ></finder-image-block>
            }
        </div>
        <!-- Timeline Image -->
        <div *ngSwitchCase="'timelineImage'" [ngClass]="block.style">
            <finder-timeline-image
                [timelineData]="block"
            ></finder-timeline-image>
        </div>
        <!-- Descriptive Text -->
        <div *ngSwitchCase="'descriptiveText'" [ngClass]="block.style">
            <finder-descriptive-text
                [data]="block"
                [imgPreload]="true"
            ></finder-descriptive-text>
        </div>
        <!-- Lottie -->
        <div *ngSwitchCase="'lottie'" [ngClass]="block.style">
            <finder-campaign-lottie
                [data]="block.lottieData"
            ></finder-campaign-lottie>
        </div>
        <!-- Iframe -->
        <div *ngSwitchCase="'iframe'" [ngClass]="block.style">
            <finder-iframe
                [headerData]="block.headerData"
                [iframeData]="block.iframeData"
            ></finder-iframe>
        </div>
        <!-- Tutorial -->
        <div *ngSwitchCase="'tutorial'" [ngClass]="block.style">
            <finder-tutorial
                [data]="block"
            ></finder-tutorial>
        </div>
    </li>
<ul>
